export default IconMoodUnamused => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-mood-unamused" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
  <path d="M11 16l4 -1.5" />
  <path d="M10 10c-.5 -1 -2.5 -1 -3 0" />
  <path d="M17 10c-.5 -1 -2.5 -1 -3 0" />
</svg>`;